var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 -3 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "drive-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-",
    transform: "translate(-601.000000, -955.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drive",
    transform: "translate(601.000000, 955.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#3777E3",
    points: "8.00048064 42 15.9998798 28 48 28 39.9998798 42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFCF63",
    points: "32.0004806 28 48 28 32.0004806 0 15.9998798 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#11A861",
    points: "0 28 8.00048064 42 24 14 15.9998798 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIcon);
export default __webpack_public_path__ + "static/media/drive-icon.81841e993ee2bc16011976e166b084fc.svg";
export { ForwardRef as ReactComponent };